module.exports = __webpack_public_path__ + "static/media/menu-ouvert.85d1e524.svg";